import React from "react";
import Banner from "./Banner";
import Footer from "./Footer";

import laradutta from "../pictures/laradutta.jpg";
import sehwag from "../pictures/sehwag_img.jpg";
import chetanChauhan from "../pictures/chetanChauhan.jpg";
import arvindsavant from "../pictures/arvindsavant.jpg";
import rohitshrma from "../pictures/rohit_shrma.jpg";
import yohan from "../pictures/yoganandshastri.jpg";
import sunilgavaskar from "../pictures/sunilgavaskar.jpg";
import sandeeppatil from "../pictures/sandeep_patil.jpg";
import chetanshrma from "../pictures/chetansharma.jpg";
import jksingh from "../pictures/jksingh.jpg";
import basandkumar from "../pictures/basandkumar.jpg";
import rajaggarwal from "../pictures/rajaggarwal.jpg";
import BrettLee from "../gallery/img7.jpg";

const Guest_And_Speaker = () => {
  return (
    <>
      <Banner />
      <div className="home_header">
        <h1 className="home_header">GUEST</h1>
      </div>

      <div className="Guest_top_container">
        <div className="Guest_top_card">
          <div className="img_brettlee">
            <img src={BrettLee} alt="not" />
          </div>
          <div className="BrettLee_header">
            <h2>Mr. Brett Lee</h2>
            <p>Former Australian cricketer</p>
          </div>
        </div>
      </div>

      <div className="Guest_container">
        <div className="Guest_card Guest_card_1">
          <div className="img_laradutta">
            <img src={laradutta} alt="not" />
          </div>
          <div className="guest_header">
            <h2>Mrs. Lara Dutta</h2>
            <p>
              Bollywood Actress
            </p>
          </div>
        </div>
        <div className="Guest_card Guest_card_2">
          <div className="img_sehwag">
            <img src={sehwag} alt="not" />
          </div>
          <div className="guest_header">
            <h2>Shri Virender Sehwag</h2>
            <p>Former Indian Cricketer</p>
          </div>
        </div>

        <div className="Guest_card Guest_card_3">
          <div className="img_chetan">
            <img src={chetanChauhan} alt="not" />
          </div>
          <div className="guest_header">
            <h2>Shri Chetan Chauhan</h2>
            <p>
              Hon'ble Minister of UP 
            </p>
          </div>
        </div>
      </div>

      <div className="Guest_container_1">
        <div className="Guest_card_1 Guest_card_4">
          <div className="img_arvind">
            <img src={arvindsavant} alt="not" />
          </div>
          <div className="guest_header">
            <h2>Shri Arvind Sawant</h2>
            <p>Hon'ble Minister of Heavy Industries and Public Enterprise</p>
          </div>
        </div>

        <div className="Guest_card_1 Guest_card_5">
          <div className="img_rohit">
            <img src={rohitshrma} alt="not" />
          </div>
          <div className="guest_header">
            <h2>Mr.Rohit Sharma</h2>
            <p>
              Indian Cricketor
            </p>
          </div>
        </div>

        <div className="Guest_card_1 Guest_card_6">
          <div className="img_yohan">
            <img src={yohan} alt="not" />
          </div>
          <div className="guest_header">
            <h2>Dr. Yoganand Shastri</h2>
            <p>Former Speaker, Delhi Legislative Assembly</p>
          </div>
        </div>
      </div>

      <div className="Guest_container_2">
        <div className="Guest_card_2 Guest_card_7">
          <div className="img_sunil">
          <img src={sunilgavaskar} alt="not" />
          </div>
          <div className="guest_header">
          <h2>Mr. Sunil Gavaskar</h2>
          <p>Former Indian Cricketer</p>
        </div>
        </div>

        <div className="Guest_card_2 Guest_card_8">
          <div className="img_sandeep">
          <img src={sandeeppatil} alt="not" />
          </div>
          <div className="guest_header">
          <h2>Shri Sandeep Patil</h2>
          <p>Former Indian Cricketer & Chief of the BCCI Selection Committee</p>
        </div>
        </div>

        <div className="Guest_card_2 Guest_card_9">
          <div className="img_chetanshrma">
          <img src={chetanshrma} alt="not" />
          </div>
        <div className="guest_header">
          <h2>Shri Chetan Sharma</h2>
          <p>Formal Indian Cricketer</p>
        </div>
       </div>
       </div>

       <div className="Guest_container_3">
        <div className="Guest_card_3 Guest_card_10">
          <div className="img_jksingh">
          <img src={jksingh} alt="not" />
          </div>
          <div className="guest_header">
          <h2>Padma Shri Dr. J. K. Singh</h2>
          <p>President, Cancer Care India 
            Former National Vice President, India Medical Association</p>
        </div>
        </div>

        <div className="Guest_card_3 Guest_card_11">
          <div className="img_basand">
          <img src={basandkumar} alt="not" />
          </div>
          <div className="guest_header">
          <h2>Shri. Vasant Kumar</h2>
          <p>Advisor, Micro, Small & Medium Enterprises (MSME)</p>
        </div>
        </div>
        <div className="Guest_card_3 Guest_card_12">
          <div className="img_rajaggrwal">
          <img src={rajaggarwal} alt="not" />
          </div>
          <div className="guest_header">
          <h2>Dr. Raj Aggarwal</h2>
          <p>Director of AIMA-CME</p>
        </div>
        </div>
        </div>

      <Footer />
    </>
  );
};

export default Guest_And_Speaker;
